export default {"src":"/_next/static/media/apeswap-lending.3862b445.svg","height":34,"width":35,"blurWidth":0,"blurHeight":0};